import type { ReactNode } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Button } from "@vlab-corporation/design-system";
import { DemoBanner } from "@/demo/DemoBanner";
import { useAuthContext } from "./AuthProvider";
import { CenterSelector } from "./CenterSelector";

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const { authState, logout, setActiveCenterId } = useAuthContext();
  const queryClient = useQueryClient();

  const handleLogout = async () => {
    queryClient.clear();
    await logout();
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <DemoBanner />

      <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
        <Link to="/" className="text-lg font-semibold text-primary-600 no-underline">
          VLAB Pilates
        </Link>
        {authState.status === "authenticated" && (
          <div className="flex items-center gap-2">
            <CenterSelector
              memberships={authState.user.memberships}
              activeCenterId={authState.user.activeMembership.centerId}
              onCenterChange={setActiveCenterId}
            />
            <span className="text-sm text-gray-600">{authState.user.name}</span>
            <Button
              variant="ghost"
              onClick={handleLogout}
              className="!text-xs !text-gray-500 !py-1 !px-2"
            >
              로그아웃
            </Button>
          </div>
        )}
      </header>

      <main className="flex-1 px-4 py-4 max-w-screen-md mx-auto w-full">{children}</main>
    </div>
  );
}
